module.exports = __webpack_public_path__ + "img/a4gb.f99691d5.svg";